import logger from 'utils/MiscUtils/main'

const jsonApiFetch = async (method, path, body) => {
  try {
    // Create base options
    const options = {
      method,
      headers: {
        'Content-Type': 'application/json',
      },
    }

    // Only add body for non-GET requests and when body is provided
    if (method !== 'GET' && body !== undefined)
      options.body = JSON.stringify(body)

    const response = await fetch(path, options)

    if (!response.ok) {
      logger.error(`Error fetching data: HTTP status:${response.status}`)
      return null
    }

    // Check if response has content before trying to parse as JSON
    const contentType = response.headers.get('content-type')
    if (contentType && contentType.includes('application/json')) {
      try {
        return await response.json()
      } catch (jsonError) {
        logger.error('Error parsing JSON response:', jsonError)
        return null
      }
    }
    // Return empty object for non-JSON responses
    return {}
  } catch (error) {
    logger.error('Error fetching data:', error)
    return null
  }
}

export default jsonApiFetch
